module.exports = __webpack_public_path__ + "img/agro.e846792f.svg";